import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { DataService } from './data.service';

export class DataTableService extends DataService {
  constructor(endPoint: string, http: HttpClient) {
    super(endPoint, http);
  }

  getAll(options: {
           pageSize?: number;
           pageIndex?: number;
           sortColumn?: string;
           sortType?: string;
           query?: string;
         }, queryParams ?: any
  ): Observable<any> {
    let paramQuery = {
      per_page: options.pageSize ?? environment.defaultPaginator.pageSize,
      page: options?.pageIndex
        ? options.pageIndex + 1
        : environment.defaultPaginator.pageIndex + 1,
      'sort_keys[]': options.sortColumn ?? '',
      'sort_dir[]': options.sortType ?? '',
      search: options.query ?? ''
    };
    return super.get('', { ...paramQuery, ...queryParams });
  }
}
